module.exports = __webpack_public_path__ + "static/media/everis-org.ed5ccb4e.png";